<template>
  <span class="msisdn">{{formattedMsisdn}}</span>
</template>

<script>
import { parsePhoneNumberFromString } from 'libphonenumber-js'

export default {
  name: 'Msisdn',
  props: {
    msisdn: {
      type: String
    }
  },
  computed: {
    normalizedMsisdn () {
      const plain = this.msisdn
      if (!plain) {
        return plain
      }
      if (/^[+0]/.test(plain) === false) {
        return `+${plain}`
      }
      return plain
    },
    formattedMsisdn () {
      if (!this.normalizedMsisdn) {
        return this.normalizedMsisdn
      }
      const parsed = parsePhoneNumberFromString(this.normalizedMsisdn, 'DE')
      return (parsed ? parsed.formatNational() : this.msisdn)
    }
  }
}
</script>
